import BasicButton from "components/BasicInputs/BasicButton";
import { useNavigate } from "react-router-dom";

const StatusComponent = ({ value, item }: { value: string; item: any }) => {
  const navigate = useNavigate();
  return (
    <div className="flex justify-center ">
      {value === "ongoing" ? (
        <BasicButton
          onClick={() => {
            if (item.Transaction) {
              return navigate(`/transactions/${item.Transaction.type}/${item.Transaction.id}`)
            }
            navigate(`/installments/transactions/add/${item.installmentType}/${item.InstallmentId}/${item.id}`);
          }}
          variant="outlined"
        >
          پرداخت
        </BasicButton>
      ) : (
        <span
          className={
            "flex items-center gap-1 flex-row px-2 py-[2px] bg-[#E7F5E9] text-[#24AF22] rounded-full font-IRANSans font-normal text-xs"
          }
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
            <path
              d="M4.25 10.4999L8.83333 15.4999L16.1272 6.80566"
              stroke="#1E8E1B"
              strokeWidth="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          {item?.dateReceived ?? ""}
        </span>
      )}
    </div>
  );
};

export default StatusComponent;
